import React from 'react';
import ValidatedInput
  from '../../../../../../../common/components/ValidatedInput';
import { FormSubHeader, PasswordInstructions } from '../styles';
import { scenarioHandlers } from './utils';

export default {
  credentialsSubHeader: {
    hide: scenarioHandlers.knownCustomer,
    component: FormSubHeader,
    readOnly: true,
    children: 'Create Password',
  },
  credentialsInstructions: {
    component: PasswordInstructions,
    hide: scenarioHandlers.knownCustomer,
    children: (
      <div>
        Passwords must contain:
        <ul>
          <li>8 characters</li>
          <li>At least 1 uppercase letter</li>
          <li>At least 1 lowercase letter</li>
          <li>At least 1 number</li>
          <li>No spaces</li>
        </ul>
      </div>
    ),
  },
  password: {
    component: ValidatedInput,
    hide: scenarioHandlers.knownCustomer,
    label: 'Password',
    type: 'password',
    required: true,
    validation: [
      {
        checkValid: value => (value || '').length <= 40,
        restrictInput: true,
        events: ['onChange'],
      },
    ],
    maxLength: 40,
    counter: true,
  },
  confirmPassword: {
    component: ValidatedInput,
    hide: scenarioHandlers.knownCustomer,
    label: 'Confirm Password',
    type: 'password',
    required: true,
    validation: [
      {
        checkValid: value => (value || '').length <= 40,
        restrictInput: true,
        events: ['onChange'],
      },
    ],
    maxLength: 40,
    counter: true,
  },
};



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/FieldConfig/credentials.js